<template>
  <div class="row mb-2">
    <div class="col">
      <h4>Membership</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-3" v-show="!isFullview">
      <!-- Title and Search -->
      <div class="row">
        <div class="col">
          <div class="input-group">
            <button type="button" class="btn btn-primary btn-sm" :disabled="isSaving" @click="refreshLocations">
              <i class="fas fa-rotate"></i>
            </button>
            <input v-model="searchText" type="text" class="form-control" placeholder="search for a location" @keyup.enter="searchLocations" /><button
              type="button"
              class="btn btn-warning btn-sm custom-btn-focus"
              title="clear search"
              @click="clearSearch"
            >
              <i class="fas fa-xmark"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm custom-btn-focus custom-divider" title="search tree" @click="searchLocations">
              <i class="fas fa-search"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm custom-btn-focus custom-divider" title="advanced search" @click="advancedSearch">
              <i class="fas fa-search"></i>
              <i class="fas fa-bolt custom-bolt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col custom-panel">
      <div class="row">
        <div class="col custom-blank">
          <div class="custom-hide" @click="isFullview = !isFullview">
            <FontAwesomeIcon v-if="!isFullview" icon="fa-solid fa-chevron-left" />
            <FontAwesomeIcon v-else icon="fa-solid fa-chevron-right" />
          </div>
        </div>
      </div>
      <!-- Action Bar -->
      <div class="row mt-2">
        <div class="col">
          <div class="col">
            <h4 class="d-inline custom-title">
              {{ title }}
            </h4>
            <span class="d-inline custom-subtitle">{{ subtitle }}</span>
            <span v-if="firmClass !== null" class="d-inline custom-firmclass ms-2">({{ firmClass }})</span>
          </div>
        </div>
        <div v-if="isSelected && isAdmin" class="col-4">
          <div class="d-flex flex-row-reverse">
            <button v-if="isAnyMemberChecked" type="button" class="btn btn-primary btn-sm ms-2" :disabled="isSaving" @click="deleteMembers">
              Remove
            </button>
            <!-- <button type="button" class="btn btn-primary btn-sm ms-2" :disabled="isSaving" @click="addMember">Add</button> -->
            <button type="button" class="btn btn-primary btn-sm ms-2" :disabled="isExporting" @click="exportMembers">
              <FontAwesomeIcon v-if="isExporting" icon="fa-solid fa-spinner" spin />
              Export
            </button>
            <button type="button" class="btn btn-primary btn-sm" :disabled="isSaving" @click="importMembers">Import</button>
          </div>
        </div>
        <div v-else-if="isSelected" class="col-4 d-flex">
          <Multiselect
            ref="searchMember"
            v-model="foundMember"
            class="form-control custom-multiselect"
            placeholder="associate member - type to search"
            :close-on-select="true"
            :filter-results="false"
            :min-chars="1"
            :resolve-on-load="false"
            :delay="500"
            :searchable="true"
            :open-direction="'bottom'"
            :options="
              async (query) => {
                return await fetchMembers(query)
              }
            "
            label="firmName"
            value-prop="firmFirm"
            @select="selectedMember"
          />
          <button class="btn btn-primary btn-sm ms-2" @click="addMemberToLocation">
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-3" v-show="!isFullview && !isAdvancedSearch">
      <!-- Location Spinner (while loading up the Location Profile) -->
      <div v-if="loading.locationTree" class="loadingWrapper">
        <div class="loadingSpinner">
          <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
          <span>loading...</span>
        </div>
      </div>
      <!-- Location Tree (on the left) -->
      <div v-else class="custom-locations-wrapper">
        <div class="row">
          <div class="col">
            <tree-node
              id="LocationTree"
              :tree="locationTree"
              :depth="0"
              :show-type="false"
              :is-open="true"
              :select-function="selectLocation"
              :class-function="getClass"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isFullview && isAdvancedSearch" class="col-3">
      <!-- Location Spinner (while loading up the Location Profile) -->
      <div v-if="loading.advancedLocations" class="loadingWrapper">
        <div class="loadingSpinner">
          <FontAwesomeIcon icon="fa-solid fa-spinner me-2" spin />
          <span>loading...</span>
        </div>
      </div>
      <div v-else class="custom-locations-wrapper">
        <ul class="custom-advanced-location-list">
          <li v-for="location in advancedLocations" :key="location.firm">
            <div
              class="tree-node-wrapper"
              :class="{
                'custom-location-selected': selectedFirm ? selectedFirm.id === location.id : ''
              }"
              @click="selectLocation(location)"
            >
              <div class="label-wrapper">
                <span>{{ location.name }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- Location Details (on the right) -->
    <div class="col-9 custom-panel" :class="{ 'col-12': isFullview }">
      <div v-if="!loading.locationTree && isSelecting" class="loadingWrapper">
        <div class="loadingSpinner">
          <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
          <span>loading...</span>
        </div>
      </div>
      <div v-else-if="!loading.locationTree && isSelected">
        <member-listing ref="membership" :firm="selectedFirm" :show-title="false" />
      </div>
    </div>
  </div>
  <!-- Dialogs -->
  <dialog-add-member v-model="actionAdd" @closing="closeModal" @saved="savedMember" />
  <dialog-import v-model="actionImport" @closing="closeModal" @saved="savedMembers" />
  <confirm-remove
    v-model="actionRemove"
    :confirm-title="confirmRemoveTitle"
    :confirm-action="confirmRemoveAction"
    :confirm-question="confirmRemoveQuestion"
    @closing="cancel"
    @proceed="performRemove"
  />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { lookupStore } from '@/stores/lookup'
import { locationStore } from '@/stores/location'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Parser } from '@json2csv/plainjs'
import moment from 'moment'
import Multiselect from '@vueform/multiselect'
import TreeNode from '@/components/utilities/elements/TreeNode.vue'
import MemberListing from '@/components/members/MemberListing.vue'
import DialogAddMember from './forms/DialogAddMember.vue'
import DialogImport from '@/components/configuration/data/DialogImport.vue'
import ConfirmRemove from '@/components/utilities/elements/ConfirmDialog.vue'
export default {
  name: 'MemberTree',
  components: {
    Multiselect,
    FontAwesomeIcon,
    TreeNode,
    MemberListing,
    DialogImport,
    DialogAddMember,
    ConfirmRemove
  },
  data() {
    return {
      actionAdd: null,
      actionImport: null,
      actionRemove: null,
      confirmRemoveTitle: 'Confirm Member Removal',
      confirmRemoveAction: 'Remove',
      confirmRemoveQuestion: 'Are you sure you wish to Permanently Remove checked members?',
      selectedFirm: null,
      isSelected: false,
      searchText: null,
      isSave: false,
      searchedTree: [],
      isScroll: false,
      showInactive: false,
      isSaving: false,
      isSelecting: false,
      foundMember: null,
      isExporting: false,
      isFullview: false,
      isAdvancedSearch: false
    }
  },
  async mounted() {
    this.isSelected = false
    this.isSelecting = false
    this.selectedFirm = null
    this.showInactive = false
    this.isAdvancedSearch = false
    this.isSaving = false
    this.isExporting = false
    await this.getLocationTree({
      firm: this.profile.firm,
      showInactive: this.showInactive,
      for: 'membership'
    })
    await this.getLookups({
      keys: ['StateProvince', 'Country', 'Language', 'TimeZone', 'FirmType', 'FirmClass'],
      firm: 1,
      refresh: false
    })
  },
  watch: {
    locationTree() {
      if (this.locationTree) {
        if (this.locationTree.members) {
          if (this.locationTree.members.length > 0) {
            console.log('Flattening the Location Tree', this.locationTree.members)
            this.processTreeFlattening(this.locationTree.members)
          }
        }
      }
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, [
      'loading',
      'location',
      'addLocation',
      'locationTree',
      'locations',
      'members',
      'isAnyMemberChecked',
      'foundMembers',
      'membersForExport',
      'advancedLocations'
    ]),
    title() {
      let _title = ''
      if (this.selectedFirm) {
        _title = this.selectedFirm.name
      }
      return _title
    },
    subtitle() {
      let _subtitle = ''
      if (this.selectedFirm) {
        _subtitle = this.selectedFirm.typeName
      }
      console.log('Subtitle', this.selectedFirm)
      return _subtitle
    },
    isLoading() {
      return this.loading.locationTree
    },
    isAdmin() {
      let _is = false
      if (this.selectedFirm && [1, 2, 3].includes(this.profile.roles[0])) {
        _is = this.selectedFirm.type === 'Corporate'
      }
      return _is
    },
    isProvider() {
      let _is = false
      if (this.selectedFirm) {
        if (this.selectedFirm.firmClass) {
          if (this.selectedFirm.firmClass === 'Provider Group' || this.selectedFirm.firmClass === 'Service Provider') {
            _is = true
          }
        }
      }
      return _is
    },
    firmClass() {
      let _firmClass = null
      if (this.selectedFirm) {
        _firmClass = this.selectedFirm.firmClass
      }
      console.log('Firm Class', _firmClass)
      return _firmClass
    }
  },
  methods: {
    ...mapActions(lookupStore, ['getLookups']),
    ...mapActions(locationStore, [
      'getLocationTree',
      'getLocation',
      'resetLocation',
      'resetMembersChecked',
      'removeMembers',
      'searchMembers',
      'resetFoundMembers',
      'saveMemberParent',
      'getMembersForExport',
      'searchAdvanced',
      'processTreeFlattening'
    ]),
    closeModal() {
      this.actionImport = null
      this.actionAdd = null
    },
    cancel() {
      this.actionRemove = null
      this.resetMembersChecked()
    },
    async fetchMembers(query) {
      this.resetFoundMembers()
      let search = {
        search: query,
        lookup: this.isProvider ? 5 : 3, // provider or insurer
        firm: this.selectedFirm.parent
      }
      return await this.searchMembers(search)
    },
    selectedMember() {
      this.$nextTick(() => {
        let found = this.foundMembers.find((x) => parseInt(x.firm) === parseInt(this.foundMember))
        if (found) {
          console.log('Found Member', found)
        }
      })
    },
    async addMemberToLocation() {
      await this.saveMemberParent({
        firmFirm: this.foundMember,
        parent: this.selectedFirm.firm
      })
      this.$refs.membership.search(1, '')
    },
    async refreshLocations() {
      this.isSelected = false
      this.isAdvancedSearch = false
      this.searchText = null
      this.selectedFirm = null
      this.resetLocation()
      await this.getLocationTree({
        firm: this.profile.firm,
        showInactive: this.showInactive,
        for: 'membership'
      })
    },
    addMember() {
      this.actionAdd = {
        parent: this.selectedFirm.parent,
        firm: this.selectedFirm.firm,
        source: this.selectedFirm.source
      }
    },
    importMembers() {
      this.actionImport = {
        title: 'Import Members',
        parent: this.selectedFirm.parent,
        parentBranch: this.selectedFirm.firm,
        source: this.selectedFirm.source
      }
    },
    deleteMembers() {
      this.actionRemove = true
    },
    async performRemove() {
      let data = []
      this.members.items.forEach((element) => {
        if (element.checked) {
          data.push({
            firmFirm: element.firmFirm
          })
        }
      })
      this.actionRemove = null
      setTimeout(async () => {
        await this.removeMembers(data)
        this.actionRemove = null
        this.resetMembersChecked()
        await this.$refs.membership.search(1, '')
      }, 200)
    },
    savedMember() {
      this.closeModal()
      this.$refs.membership.search(1, '')
    },
    savedMembers() {
      this.closeModal()
      this.$refs.membership.search(1, '')
    },
    async selectLocation(tree) {
      this.isSelecting = true
      this.isSelected = false
      // select our location and get
      // the location information
      await this.getLocation(tree.id)
      this.isSelecting = false
      setTimeout(() => {
        this.isSelected = true
      }, 150)
      console.log('Selecting Firm', tree)
      this.selectedFirm = {
        parent: tree.parent,
        id: tree.id,
        firm: tree.id,
        name: tree.name,
        type: tree.type,
        typeName: tree.typeName,
        contact: tree.contact,
        firmClass: tree.firmClass
      }
      this.setSelection(tree.id)
      this.isSave = false
      setTimeout(() => {
        if (this.$refs.membership) {
          this.$refs.membership.search(1, '')
        }
      }, 350)
    },
    setSelection(id) {
      if (!this.isAdvancedSearch) {
        // highlight the node in the tree
        var x = document.getElementsByClassName('tree-node-selection')
        if (x !== undefined && x !== null) {
          for (var i = 0; i < x.length; i++) {
            x[i].classList.remove('tree-node-selection')
          }
          x = document.getElementById(id)
          x.classList.add('tree-node-selection')
          if (this.isScroll) {
            x.scrollIntoView()
          }
        }
      }
    },
    resetFound() {
      var x = document.getElementsByClassName('tree-node-found')
      if (x !== undefined && x !== null) {
        for (var i = 0; i < x.length; i++) {
          x[i].classList.remove('tree-node-found')
        }
      }
    },
    setFound(id) {
      var x = document.getElementById(id)
      if (x) {
        x.classList.add('tree-node-found')
      }
    },
    closeTreeNodes(node, rootPath) {
      // loop through the tree and set
      // the isOpen flag to false, closing
      // all nodes
      rootPath.push(node)
      node.isOpen = false
      if (node.members) {
        if (node.members.length > 0) {
          node.members.forEach((element) => {
            this.closeTreeNodes(element, rootPath)
          })
        }
      }
      rootPath.pop()
    },
    openTreeNode(id, node, rootPath) {
      // loop through the tree and set
      // the isOpen flag to open up the
      // appropriate nodes
      rootPath.push(node)
      if (node.id === id) {
        node.isOpen = true
      }
      if (node.members) {
        if (node.members.length > 0) {
          node.members.forEach((element) => {
            this.openTreeNode(id, element, rootPath)
          })
        }
      }
      rootPath.pop()
    },
    traverseTree(search, node, rootPath) {
      // this is an iterative tree search to find our
      // location based upon name
      rootPath.push(node)
      if (node.name.includes(search)) {
        rootPath.forEach((element) => {
          this.searchedTree.push({
            id: element.id,
            name: element.name,
            type: element.type
          })
        })
      }
      if (node.members) {
        if (node.members.length > 0) {
          node.members.forEach((element) => {
            this.traverseTree(search, element, rootPath)
          })
        }
      }
      rootPath.pop()
    },
    traverseTreeById(id, node, rootPath) {
      // this is an iterative tree search to find our
      // location based upon name
      rootPath.push(node)
      if (parseInt(node.id) === parseInt(id)) {
        rootPath.forEach((element) => {
          this.searchedTree.push({
            id: element.id,
            name: element.name,
            type: element.type
          })
        })
      }
      if (node.members) {
        if (node.members.length > 0) {
          node.members.forEach((element) => {
            this.traverseTreeById(id, element, rootPath)
          })
        }
      }
      rootPath.pop()
    },
    clearSearch() {
      this.resetFound()
      this.selectedFirm = null
      this.refreshLocations()
    },
    async searchLocations() {
      let path = []
      this.isAdvancedSearch = false
      if (this.searchText === null) {
        this.searchText = ''
      }
      // close all nodes first
      this.closeTreeNodes(this.locationTree, path)
      this.resetFound()
      path = []
      this.searchedTree = []
      // traverse the tree looking for location
      if (this.searchText) {
        this.traverseTree(this.searchText, this.locationTree, path)
      } else {
        this.traverseTreeById(this.selectedFirm.id, this.locationTree, path)
      }
      // if found, open up the tree accordingly
      if (this.searchedTree.length > 0) {
        path = []
        for (let idx = 0; idx < this.searchedTree.length; idx++) {
          const element = this.searchedTree[idx]
          this.openTreeNode(element.id, this.locationTree, path)
          this.$forceUpdate()
          // and select it...
          if (idx === this.searchedTree.length - 1) {
            this.isScroll = true
            await this.selectLocation(element)
            this.isScroll = false
          }
        }
        if (this.searchText) {
          for (let idx = 0; idx < this.searchedTree.length; idx++) {
            const element = this.searchedTree[idx]
            // indicate found
            if (element.name.includes(this.searchText)) {
              this.setFound(element.id)
            }
          }
        }
      }
    },
    async advancedSearch() {
      this.isAdvancedSearch = false
      if (this.searchText === null) {
        this.searchText = ''
      }
      if (this.searchText.length !== 0) {
        let options = {
          firm: this.profile.firm,
          search: this.searchText,
          type: 99
        }
        await this.searchAdvanced(options)
        if (this.advancedLocations) {
          this.isAdvancedSearch = true
        }
      }
    },
    getClass(type) {
      let result = null
      switch (type) {
        case 'Admin':
          result = 'custom-dark-green'
          break
        case 'Corporate':
          result = 'custom-orange'
          break
        case 'Division':
          result = 'custom-blue-italic'
          break
        case 'Distributor':
          result = 'custom-green'
          break
        case 'Partner':
          result = 'custom-black-italic'
          break
        case 'Center':
          result = 'custom-green-italic'
          break
        default:
          break
      }
      return result
    },
    async exportMembers() {
      this.isExporting = true
      await this.getMembersForExport({
        firm: this.location.firm,
        type: 99,
        filter: 'root'
      })
      if (this.membersForExport.length > 0) {
        this.processExport()
      }
      this.isExporting = false
    },
    async processExport() {
      try {
        const parser = new Parser()
        const csv = parser.parse(this.membersForExport)
        let now = moment().format('YYYY-MM-DD')
        console.log(csv)
        // download the file as CSV
        var downloadLink = document.createElement('a')
        var blob = new Blob(['\ufeff', csv])
        var url = URL.createObjectURL(blob)
        downloadLink.href = url
        downloadLink.download = `Membership for ${this.location.firmName} ${now}.csv`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-blank {
  height: 30px;
  position: absolute;
  width: 200px;
}
.custom-locations-wrapper {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}
.loadingWrapper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  // background: rgba(0, 0, 0, 0.2);
  z-index: 10;
}
.loadingSpinner {
  margin-top: 40px;
  text-align: center;
  font-weight: 700;
  width: 100%;
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  span {
    margin-left: 5px;
  }
}
.custom-title {
  margin-left: 20px;
}
.tree-node-selection {
  background-color: rgb(255, 255, 187);
}
.tree-node-wrapper {
  border-bottom: 1px solid #b8b8b8;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
}
.tree-node {
  .label-wrapper {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    .has-children {
      cursor: pointer;
    }
  }
}
.tree-link {
  width: 100%;
  a {
    display: inline-block;
    width: 100%;
  }
}
.tree-link:hover {
  color: white;
  background: #2f9af7;
}
.custom-subtitle {
  font-style: italic;
  margin-left: 10px;
}
.custom-panel {
  position: relative;
  border-left: 1px solid #b8b8b8;
}
.custom-hide {
  position: absolute;
  padding-left: 5px;
  padding-top: 5px;
  background-color: #007bff;
  color: white;
  left: 0;
  border: 1px solid #007bff;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 36px;
  width: 25px;
  :hover {
    cursor: pointer;
  }
}
.custom-advanced-location-list {
  list-style-type: none;
  padding-left: 20px;
  :hover {
    cursor: pointer;
    background-color: rgb(219, 219, 219);
  }
}
.custom-btn-focus:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
  border: 1px solid #ced4da;
}
.custom-divider {
  border-left: #ced4da 1px solid;
}
.custom-bolt {
  position: absolute;
  top: 3px;
  right: 2px;
  font-size: 0.8em;
}
.custom-location-selected {
  background-color: rgb(255, 255, 187);
}
.custom-firmclass {
  font-style: italic;
  font-size: 0.8em;
  margin-left: 10px;
}
</style>
